import { render, staticRenderFns } from "./ProductivitySummary.vue?vue&type=template&id=46d7e3b5&"
import script from "./ProductivitySummary.vue?vue&type=script&lang=js&"
export * from "./ProductivitySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports